import { Box, Heading, Image, Text } from '@wix/design-system'
import { useContent, useNext } from '@wix/funnel-builder-lizard'
import React, { FC, useEffect } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { useBrowserTabTitle } from '../../../hooks/useBrowserTabTitle'
import WixStudioLogo from '../../reusable/icons/WixStudioLogo.svg'
import type { Content } from './Content'
import { dataHooks } from './WixStudioMobileStores.dataHooks'
import s from './WixStudioMobileStores.scss'

export const WixStudioMobileStores: FC = () => {
  const { content } = useContent<Content>()
  const { questionKey } = content.question
  useBrowserTabTitle(content.browserTabTitle)

  const next = useNext()
  const pageLogger = usePageLogger()

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  const handleClick = (optionKey: string) => {
    void pageLogger.answer({ answer: optionKey })
    next({ [questionKey]: { values: [optionKey] } })
  }

  return (
    <Box
      direction="vertical"
      width="100%"
      align="center"
      padding="20px 18px"
      boxSizing="border-box"
      className={s.container}
    >
      <Box marginTop="40px">
        <WixStudioLogo width="187" height="auto" />
      </Box>
      <Box marginTop="SP10" marginBottom="SP7" textAlign="center" direction="vertical">
        <Heading className={s.title} dataHook={dataHooks.title()}>
          {content.title}
        </Heading>
        <Box marginTop="SP2">
          <Text size="medium" dataHook={dataHooks.subtitle()} className={s.text}>
            {content.subtitle}
          </Text>
        </Box>
      </Box>
      <Box gap="12px" align="center">
        {content.question.options.map(({ image, optionKey }, index) => (
          <img
            key={`${optionKey}${index}`}
            src={image}
            alt=""
            height="42px"
            width="auto"
            onClick={() => handleClick(optionKey)}
            data-hook={dataHooks.image({ index })}
          />
        ))}
      </Box>
      <Image src={content.backgroundImage} className={s.graphics} />
    </Box>
  )
}
